import React from 'react';
import {
  PictureAsPdf as PdfIcon,
  InsertDriveFile as FileIcon,
  Description as WordIcon,
  TableChart as ExcelIcon,
  Slideshow as PowerpointIcon,
} from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { getFileKind } from '../../lib/cfos/fileKind';

type FileTypeIconProps = {
  filename: string;
  fontSize?: SvgIconProps['fontSize'];
};

/** Colored glyph for common document types (PDF / Office / generic). */
const FileTypeIcon: React.FC<FileTypeIconProps> = ({ filename, fontSize = 'small' }) => {
  switch (getFileKind(filename)) {
    case 'pdf':
      return <PdfIcon fontSize={fontSize} sx={{ color: '#E53935' }} />;
    case 'word':
      return <WordIcon fontSize={fontSize} sx={{ color: '#2B579A' }} />;
    case 'excel':
      return <ExcelIcon fontSize={fontSize} sx={{ color: '#217346' }} />;
    case 'powerpoint':
      return <PowerpointIcon fontSize={fontSize} sx={{ color: '#C43E1C' }} />;
    default:
      return <FileIcon fontSize={fontSize} color="action" />;
  }
};

export default FileTypeIcon;
